const DirectoryAlphaCounts = (labelCounts) => {
	/*
        This will generate a count map of each letter of the alphabet plus
        a 'catch all' which will just be an asterisk (*). This is case
        insensitive so all alphabet chars will be uppercased.

        Anything that is not A-Z will be thrown in the catch all bucket.

        labelCounts is presumed to be an array of objects with the keys
        _id and value where _id is the character and value is the user
        count for that character. EX:

        labelCounts = [
            { _id: "A", value: 2 },
            { _id: "a", value: 1 }
        ];

    */

	const userLabelCounts = {};
	const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

	labelCounts.forEach((item) => {
		// parse the letter
		let letter;

		try {
			letter = item._id.toUpperCase();
		} catch (err) {
			letter = "*";
		}

		letter = letters.indexOf(letter) < 0 ? "*" : letter;

		// get the current count
		const currentCount = Object.prototype.hasOwnProperty.call(userLabelCounts, letter)
			? userLabelCounts[letter].count
			: 0;

		// set the value
		userLabelCounts[letter] = { count: currentCount + item.value };
	});

	return userLabelCounts;
};

export default DirectoryAlphaCounts;
